import React from 'react';

import {useDispatch} from 'react-redux';

import {useCurrentUserState} from 'app/current-user/api';
import {useAccountSettingsState} from 'app/settings/api';

import PreparedFroalaEditor from './PreparedFroalaEditor';

interface Props {
  value?: string;
  onChange: (content: string) => void;
  scrollableContainer?: string;
  options?: Record<string, unknown>;
  contentType: string;
  objectId: number | string;
  onEditorIsBusyChange?: (busy: boolean) => void;
  onCloseRequest: () => unknown;
  onInitialized?: () => unknown;
}

export function RichTextarea({
  options = {},
  scrollableContainer = '.scrollable-container',
  onCloseRequest,
  ...other
}: Props): JSX.Element {
  const {account_id, MEDIA_URL, MEDIA_URL_READ, s3Upload} =
    useAccountSettingsState().data!;
  const {language} = useCurrentUserState().data!;
  const dispatch = useDispatch();

  const normalizedOptions = {...options, scrollableContainer, onCloseRequest};

  return (
    <PreparedFroalaEditor
      language={language}
      accountId={account_id}
      mediaURL={MEDIA_URL}
      mediaURLRead={MEDIA_URL_READ}
      // send as new objects because awsUploadSigner plugin update them
      videosS3UploadConfig={{...s3Upload.VIDEOS}}
      imagesS3UploadConfig={{...s3Upload.IMAGES}}
      options={normalizedOptions}
      reduxDispatch={dispatch}
      {...other}
    />
  );
}
